// extracted by mini-css-extract-plugin
export default {"solutionList__Style":"TrainingAndDev_solutionList__Style__Qd+yn","trainingItem__style":"TrainingAndDev_trainingItem__style__ynf8W"};